module.exports = __webpack_public_path__ + "static/media/fete.164602f9.jpeg";